export default {
  getToken: (state) => state.token,
  getUsername: (state) => state.username,
  getBudgetDocumentId: (state) => state.budgetDocument?.id,
  getMovie: (state, getters, rootState) => rootState['movies/movies']?.find((m) => m.movieId === state.budgetDocument?.movieId),
  isLoggedIn: (state, getters) => getters.getToken?.length > 0,
  isAnonymous: (state, getters, rootState) => {
    switch (rootState.route?.name) {
      case 'newCrew':
        return true;
      default:
        return false;
    }
  },
};
